"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withDefaults = withDefaults;
function withDefaults(config) {
    return {
        ...config,
        i18n: {
            ...config.i18n,
            localePrefix: config.i18n.localePrefix ?? "as-needed",
        },
        theme: {
            defaultTheme: config.theme?.defaultTheme ?? "default",
        },
        footer: {
            showStatus: config.footer?.showStatus ?? true,
            statusUrl: config.footer?.statusUrl,
            showAnalytics: config.footer?.showAnalytics ?? true,
            analyticsUrl: config.footer?.analyticsUrl,
        },
    };
}
